// src/store/actions.js
// 定义方法类型名 调用的时候 dispatch(increment()); // 相当于 dispatch({ type: 'INCREMENT' })
export const increment = (step = 1) => ({
    type: 'INCREMENT',
    payload: step, // 将步长作为 payload 传递
});

export const decrement = (step = 1) => ({
    type: 'DECREMENT',
    payload: step, // 将步长作为 payload 传递
});

export const setUserInfo = (userInfo={}) => ({
    type: 'SETUSERINFO',
    payload: userInfo, // 将步长作为 payload 传递
});
